import React, { useState } from 'react';
import { Typography, Box, useMediaQuery, useTheme, Grid, FormControl } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Select } from '../../../../../Components';
import { useStyles } from '../../../../../Components/Field/Field.styles';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import { StepProps } from './types';
import { ValueType } from 'react-select';
import UpdateConnectionInfo from './UpdateConnectionInfo';

const PRIMARY = '#c4122f';

interface Step2SelectTypeProps extends StepProps {
  typeOptions: SelectOption[];
  selectedType?: SelectOption;
  onTypeSelect: (type: SelectOption) => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step2SelectType = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  typeOptions,
  selectedType,
  onTypeSelect,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step2SelectTypeProps) => {
  const [localSelected, setLocalSelected] = useState<SelectOption | undefined>(selectedType);
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const classes = useStyles();

  const handleChange = (selected: ValueType<SelectOption>) => {
    if (selected) {
      setLocalSelected(selected as SelectOption);
    }
  };

  const handleNext = () => {
    if (localSelected) {
      onTypeSelect(localSelected);
      onNext();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Box style={{ maxWidth: '100%', width: '100%', minWidth: '320px' }}>
                  <FormControl className={classes.formControl} style={{ width: '100%' }}>
                    <Typography className={classes.label} component="label">
                      {formatMessage({ id: 'law-portal.manage.update-requirements.type' })}
                    </Typography>
                    <Select
                      selectProps={{
                        options: typeOptions,
                        placeholder: formatMessage({ id: 'law-portal.manage.update-requirements.type.placeholder' }),
                        value: localSelected ? { label: localSelected.label, value: localSelected.value } : null,
                        onChange: handleChange,
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
        updateConnectionInfo={updateConnectionInfo}
        currentStepName={currentStepName}
        onUpdate={setUpdateConnectionInfo}
      />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelected}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step2SelectType;
